'use strict';

const {degToRad, radToDeg} = require('../utils/misc');

function Point (x, y, precision) {
    if (isNaN(x) || isNaN(y)) {
        debugger;
        throw new Error('You may not construct a Point with NaN values');
    }
    this.precision = precision || this.precision;
    this.x = Math.round(x * Math.pow(10, this.precision))/Math.pow(10, this.precision);
    this.y = Math.round(y * Math.pow(10, this.precision))/Math.pow(10, this.precision);
}

Point.prototype.precision = 4;
Point.prototype.isAPoint = true;

//Can act like a shape
Point.prototype.getPoints = function () {
    return [this];
};

Point.prototype.averageWith = function (otherPoint) {
    return this.proportionateJump(otherPoint, 1/2);
};

Point.prototype.proportionateJump = function (otherPoint, proportion) {
    const diffX = this.x - otherPoint.x;
    const x = this.x - diffX * proportion;
    const diffY = this.y - otherPoint.y;
    const y = this.y - diffY * proportion;
    return new Point(x, y);
};

Point.prototype.toString = function () {
    return `Point(${this.x}, ${this.y})`;
};

Point.prototype.clone = function () {
    return new Point(this.x, this.y);
};

Point.prototype.diff = function (otherPoint) {
    return new Point(otherPoint.x - this.x, otherPoint.y - this.y);
};

Point.prototype.distance = function (otherPoint) {
    const xDelta = otherPoint.x - this.x;
    const yDelta = otherPoint.y - this.y;
    return Math.sqrt(Math.pow(xDelta, 2) + Math.pow(yDelta, 2));
};

Point.prototype.translate = function (xD, yD) {
    if (xD && xD.isAPoint) {
        return new Point(this.x + xD.x, this.y + xD.y);
    } else {
        return new Point(this.x + xD, this.y + yD);
    }
};

Point.prototype.delta = function (otherPoint) {
    return [otherPoint.x - this.x, otherPoint.y - this.y];
};

Point.prototype.angleTo = function (otherPoint) {
    if (otherPoint.x === this.x) {
        if (otherPoint.y === this.y) {
            return 0;
        }
        return otherPoint.y > this.y ? 90 : 270;
    }
    if (otherPoint.y === this.y) {
        return otherPoint.x > this.x ? 0 : 180;
    }
    const xD = Math.abs(otherPoint.x - this.x);
    const yD = Math.abs(otherPoint.y - this.y);
    const theta = radToDeg(Math.atan(yD / xD));
    if (otherPoint.x > this.x) {
        if (otherPoint.y > this.y) {
            return theta;
        } else {
            return 360 - theta;
        }
    } else {
        if (otherPoint.y > this.y) {
            return 180 - theta;
        } else {
            return 180 + theta;
        }
    }
};

Point.prototype.radialPoint = function (distance, theta) {
    while (theta < 0) theta += 360;
    theta = theta % 360;
    const xDelta = Math.cos(degToRad(theta)) * distance;
    const yDelta = Math.sin(degToRad(theta)) * distance;
    return new Point(this.x + xDelta, this.y + yDelta);
};

Point.prototype.annotate = function (ctx, text, theta, distance, font) {
    ctx.font = font || '1em serif';
    let annotationPoint = this.radialPoint(distance || 20, theta || 0);
    //console.log(`${this} annotating ${text} at ${theta} -> ${annotationPoint}`);
    ctx.fillTextAtPoint(text, annotationPoint);
};

Point.prototype.pointsBetween = function (otherPoint, num, inclusive) {
    const points = [];

    if (inclusive) {
        points.push(this);
    }
    const xDelta = (otherPoint.x - this.x) / (num + 1);
    const yDelta = (otherPoint.y - this.y) / (num + 1);
    for (let i = 1; i <= num; i++) {
        points.push(this.translate(xDelta * i, yDelta * i));
    }

    if (inclusive) {
        points.push(otherPoint);
    }
    return points;
};

Point.origin = function () {
    return new Point(0, 0);
};

Point.minX = function (points) {
    if (points.getPoints) {
        points = points.getPoints();
    }
    if (points.length && !points[0]) {
        debugger;
    }
    return Math.min.apply(Math, points.map(p => p.x));
};

Point.minY = function (points) {
    if (points.getPoints) {
        points = points.getPoints();
    }
    return Math.min.apply(Math, points.map(p => p.y));
};

Point.maxX = function (points) {
    if (points.getPoints) {
        points = points.getPoints();
    }
    return Math.max.apply(Math, points.map(p => p.x));
};

Point.maxY = function (points) {
    if (points.getPoints) {
        points = points.getPoints();
    }
    return Math.max.apply(Math, points.map(p => p.y));
};

Point.mkMinPoint = function (points) {
    return new Point(Point.minX(points), Point.minY(points));
};

Point.mk = function (x, y) {
    return new Point(x, y);
}


module.exports = Point;
